import { ButtonHTMLAttributes, DetailedHTMLProps, FC, MouseEventHandler } from "react";
import clsx from "clsx";
import CustomIcon from "@/components/ui/custom-icon";
import S from "./index.module.scss";

type SliderArrowButtonProps = {
  direction: "prev" | "next";
  tone?: "light" | "dark";
  onClick?: MouseEventHandler<HTMLButtonElement>;
  className?: string;
} & DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>;

const SliderArrowButton: FC<SliderArrowButtonProps> = ({ direction, tone = "light", onClick, className, ...rest }) => {
  return (
    <button
      type="button"
      aria-label={direction === "next" ? "Следующий" : "Предыдущий"}
      onClick={onClick}
      className={clsx(S.button, direction === "prev" ? S.prev : S.next, tone === "dark" ? S.dark : S.light, className)}
      {...rest}
    >
      <CustomIcon fileName="icon-arrow" className={S.icon} />
    </button>
  );
};

export default SliderArrowButton;
